import React from "react";
import { Page } from "../components";
import "./NotFound.css";

export default function NotFound() {  
  return <Page title="Sorry!! the Page is Not Found"/>;
}
